import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { CheckCircleSolid as e$1 } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/check-circle-solid.es.es.js";
import { ExclamationCircleSolid as l } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/exclamation-circle-solid.es.es.js";
import { InfoCircleSolid as t } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/info-circle-solid.es.es.js";
import { TimesCircleSolid as e } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/times-circle-solid.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
function SnackBarIcon({
  variant
}) {
  switch (variant) {
    case "success":
      return /* @__PURE__ */ jsx(e$1, { "data-testid": "snackbar-success-icon" });
    case "error":
      return /* @__PURE__ */ jsx(e, { "data-testid": "snackbar-error-icon" });
    case "warning":
      return /* @__PURE__ */ jsx(l, { "data-testid": "snackbar-warning-icon" });
    default:
      return /* @__PURE__ */ jsx(t, { "data-testid": "snackbar-info-icon" });
  }
}
export {
  SnackBarIcon
};
//# sourceMappingURL=snackbar-icon.es.js.map
